module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lJx5U"))).then(() => parcelRequire('2tVGr'));